import { type ObjectValuesUnionType } from '../utils/typing';

export const ScoreBoardMatchPeriods = Object.freeze({
  PEN: 'pen',
  MANUAL_LIVE: 'manual_live',
});

export type ScoreBoardMatchPeriod = ObjectValuesUnionType<typeof ScoreBoardMatchPeriods>;
